import { DateTime } from "luxon";
import type { AppointmentListFragment } from "@/gql/graphql";
import { UpdateAppointmentInput } from "@/gql/graphql";
import { timezoneUtils } from "@/lib/timezone";

export const PAGE_SIZE = 50;

export type AppointmentDateRange = "today" | "upcoming" | "all";

export const getDateRangeStart = (dateRange: AppointmentDateRange): DateTime => {
  const now = DateTime.now();
  switch (dateRange) {
    case "today":
      return now.startOf("day");
    case "upcoming":
      return now;
    default:
      return now.startOf("day");
  }
};

export const cleanUpdateInput = (
  updates: Partial<UpdateAppointmentInput>
): Record<string, unknown> => {
  return Object.entries(updates).reduce(
    (acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, unknown>
  );
};

export const sortAppointmentsByStartTime = (
  appointments: AppointmentListFragment[],
  options: {
    useCreatedAtFallback?: boolean;
  } = {}
): AppointmentListFragment[] => {
  const { useCreatedAtFallback = true } = options;

  return [...appointments].sort((a, b) => {
    const aTime = timezoneUtils.fromISO(a.startTime);
    const bTime = timezoneUtils.fromISO(b.startTime);

    // Primary sort by startTime
    const timeDiff = aTime.diff(bTime).toMillis();
    if (timeDiff !== 0) {
      return timeDiff;
    }

    // Secondary sort by id when startTimes are equal (stable sort)
    if (useCreatedAtFallback) {
      return a.id.localeCompare(b.id);
    }

    return 0;
  });
};
